import { Status } from '@essent/common';
import type { GetAddressResponse } from '@essent/extension-offer';
import {
  getAddress,
  getAddressClear,
  getAddressError,
  getAddressSuccess,
} from '@essent/extension-offer';
import type { CollectionState } from '@innogy/utils-state';
import {
  createInitialCollectionState,
  updateCollectionState,
} from '@innogy/utils-state';
import type { Action } from '@ngrx/store';
import { createReducer, on } from '@ngrx/store';

export type AddressState = CollectionState<GetAddressResponse>;

const initialState: AddressState = createInitialCollectionState();

const _addressReducer = createReducer(
  initialState,
  on(getAddress, (state, action) =>
    updateCollectionState(state, action, {
      status: Status.PENDING,
    })
  ),
  on(getAddressSuccess, (state, action) =>
    updateCollectionState(state, action, {
      status: Status.SUCCESS,
      entry: action.payload,
    })
  ),
  on(getAddressError, (state, action) =>
    updateCollectionState(state, action, {
      status: Status.ERROR,
      error: action.payload,
    })
  ),
  on(getAddressClear, (_) => initialState)
);

export function addressReducer(
  state: AddressState = initialState,
  action: Action
): AddressState {
  return _addressReducer(state, action);
}
